/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t){return"object"==typeof t&&Object.prototype.hasOwnProperty.call(t,"current")}export{t as isRefObject};
//# sourceMappingURL=is-ref-object.js.map
